import React from 'react';
import './App.css';
import Header from './components/header/Header';
import Home from './components/home/Home';
import Education from './components/education/Education';
import Skills from './components/skills/Skills';
import Work from './components/work/Work';
import Contact from './components/contact/Contact';
import Footer from './components/footer/Footer';
import ScrollUp from './components/scrollup/ScrollUp';


function App() {
  return (
    <>
    <Header />

    <main className='main'>
      <Home />
      <Education />
      <Skills />
      <Work />
      <Contact />
      
     


    </main>
    <Footer />
    <ScrollUp />
    </>
  );
}

export default App;
